// top-banner.js
import React from "react";
import "./styles/top-banner.css";

const TopBanner = () => {
  return (
    <section className="top-banner" aria-label="Goatt হোমপেজ হিরো সেকশন">
      {/* Decorative floating icons */}
      <div className="float-icons" aria-hidden="true">
        <svg className="icon icon--book" viewBox="0 0 24 24">
          <path d="M3 4.5A2.5 2.5 0 0 1 5.5 2H20v18H6a2 2 0 0 0-2 2H3V4.5z" />
          <path d="M6 2v16.5A2.5 2.5 0 0 1 3.5 21" />
        </svg>
        <svg className="icon icon--cap" viewBox="0 0 24 24">
          <path d="M2 10l10-5 10 5-10 5-10-5z" />
          <path d="M12 15v6" />
          <path d="M7 12v4c0 1.1 2.24 2 5 2s5-.9 5-2v-4" />
        </svg>
        <svg className="icon icon--pin" viewBox="0 0 24 24">
          <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
        </svg>
      </div>

      {/* Background pattern (SVG) */}
      <div className="bg-pattern" aria-hidden="true">
        <svg width="100%" height="100%">
          <defs>
            <pattern
              id="dots"
              x="0"
              y="0"
              width="24"
              height="24"
              patternUnits="userSpaceOnUse"
            >
              <circle cx="1" cy="1" r="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>
      </div>

      <div className="top-banner__content">
        <p className="eyebrow">Goatt • বাংলাদেশ</p>
        <h1 className="headline">
          Less stress. <span className="soft-break">More A’s.</span>
        </h1>
        <p className="subheadline">
          From honest faculty reviews to perfect-fit tutors—right here.
        </p>

        <div className="cta-group">
          <a className="btn btn--primary" href="https://tn.goatteachers.com/">
            <span className="emoji" aria-hidden="true">
              🎓
            </span>{" "}
            Find Tutors
          </a>
          <a
            className="btn btn--ghost"
            href="  /rating-network"
            rel="noopener noreferrer"
          >
            <span className="emoji" aria-hidden="true">
              🔍
            </span>{" "}
            Review University
          </a>
        </div>

        <ul className="trust-points" aria-label="বিশ্বস্ততার বৈশিষ্ট্য">
          <li>রিয়েল শিক্ষার্থী রিভিউ</li>
          <li>ভেরিফায়েড টিউটর প্রোফাইল</li>
          <li>বাংলাদেশ-কেন্দ্রিক ফিল্টার</li>
        </ul>
      </div>
    </section>
  );
};

export default TopBanner;
